// extracted by mini-css-extract-plugin
export default {"sliderOptions":"contextual-menu-slider-options-module__sliderOptions--ZmTO8"};